<script>
    import moment from "moment";
	import { mapState, mapActions } from "vuex";
	import ClientFactory from "@/api/ClientFactory";
	const api = ClientFactory.get("briefingCollection");
	import UploadFile from '../../../components/files/Upload.vue';

	export default {
		components: {
			UploadFile,
		},
		data() {
			return {
				inputReportTitle: "",
                inputReportContent: "",
				inputYear: new Date().getFullYear(),
				inputMonth: new Date().getMonth() + 1,
                inputReportDate: new Date(),
				dialog: {
					active: false
				},
				attachments: {
					files: [],
				},
				attachmentsFilesName: {
					files: [],
				},
			};
		},
		methods: {
			...mapActions("ui", ["loading", "closeLoading", "notify"]),
			async create() {
				this.$validator.validateAll();
				if (!this.validator()) {
					return this.notify({
						error: true,
						text: "Dữ liệu không hợp lệ.",
					});
				}
				if(this.attachments.files.length == 0) {
					return this.notify({
						error: true,
						text: 'Tệp tin đính kèm là bắt buộc',
					});
				}
				this.loading(this.$vs);

				let response = await api.insReport({
					briefings_month: this.inputMonth,
                    briefings_year: this.inputYear,
                    department_id: this.AppActiveUser.department_id,
                    report_date: moment(this.inputReportDate).format("DD/MM/YYYY"),
                    report_title: this.inputReportTitle,
                    report_content:  this.inputReportContent,
                    file_id: this.attachments.files
				});

				if (
					typeof response.error !== "undefined" ||
					response.data.status === "failed"
				) {
					this.closeLoading();
					return this.notify({
						error: true,
						text: response.error || response.data.message,
					});
				} else {
					this.$router.back();
					this.closeLoading();
					return this.notify({
						text: "Thêm mới dữ liệu thành công",
					});
				}
			},
			validator() {
				return (
					!this.errors.any() &&
					this.inputReportTitle !== "" &&
					this.inputMonth !== "" &&
                    this.inputYear !== "" &&
                    this.inputReportDate !== ""
				);
			},
			displayUploadDialog() {
				this.dialog.active = true;
			},
			uploadDone() {
				this.dialog.active = false;
				this.attachments.files = this.$refs.uploadDialog.fileIds;
				this.attachmentsFilesName.files = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
					return item.file.name
				})
			},
		},
		destroyed() {
			this.closeLoading();
		},
        computed: {
            ...mapState("auth", ["AppActiveUser"]),
        },
	};
</script>
<template>
	<div id="briefings-report-create">
		<CCard>
			<CCardHeader>
				<span class="card-header-title">Thêm báo cáo của Sở</span>
			</CCardHeader>
			<CCardBody>
				<CRow class="mb-2">
					<CCol md="8">
						<CInput
							v-model="inputReportTitle"
							label="Tên báo cáo (*)"
							v-validate="'required'"
							name="Tên báo cáo"
							placeholder="Điền tên báo cáo trước giao ban"
						/>
						<span class="text-danger text-sm">{{
							errors.first("Tên báo cáo")
						}}</span>
					</CCol>
                    <CCol md="4">
						<CInput
							label="Phòng ban"
                            :value="this.AppActiveUser.department_name"
                            readonly
						/>
					</CCol>
				</CRow>
				<CRow class="mb-2">
					<CCol md="12">
						<CTextarea
							v-model="inputReportContent"
							label="Nội dung"
							rows="5"
							placeholder="Điền nội dung tóm tắt báo cáo trước giao ban"
						/>
					</CCol>
				</CRow>
				<CRow class="mb-2">
					<CCol md="2">
						<CInput
							v-model="inputYear"
							type="number"
							label="Năm (*)"
							v-validate="'required'"
							name="Năm"
						/>
						<span class="text-danger text-sm">{{
							errors.first("Năm")
						}}</span>
					</CCol>
					<CCol md="2">
						<CSelect
							:value.sync="inputMonth"
							label="Tháng"
							:options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
						/>
					</CCol>
					<CCol md="2">
						<label for="datepicker">Ngày nộp</label>
						<b-form-datepicker
							id="datepicker"
							v-model="inputReportDate"
							class="mb-2"
                            locale="vi"
                            placeholder="Chọn ngày nộp"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            :hide-header=true
                            label-help=""
                            :value-as-date=true
						></b-form-datepicker>
					</CCol>
					<CCol md="2">
						<span>File đính kèm (*)</span>
						<vs-button class="mt-2 ml-0" square danger @click="displayUploadDialog"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
						<span v-if="this.attachments.files.length > 0" style="color: #2eb85c" class="small">Đã tải lên {{this.attachments.files.length}} tệp tin</span>
					</CCol>
				</CRow>
				
			</CCardBody>
			<CCardFooter>
				<CRow>
					<CCol md="12">
						<div class="text-center">
							<vs-button
								class="d-inline custom_btn_search"
								square
								danger
								@click="$router.back()"
								><i class='bx bx-left-arrow-alt'></i>&nbsp; Quay lại</vs-button
							>
							<vs-button class="d-inline" square @click="create"
								><i class='bx bxs-save'></i>&nbsp; Thêm mới</vs-button
							>
							
						</div>
					</CCol>
				</CRow>
			</CCardFooter>
		</CCard>
		<vs-dialog prevent-close width="600px" scroll overflow-hidden v-model="dialog.active">
            <template #header>
                <h4 class="not-margin">
                <b>Tải lên</b>
                </h4>
            </template>
            <UploadFile ref="uploadDialog"/>
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button square success @click="$refs.uploadDialog.uploadFiles()"><i class="bx bx-cloud-upload"></i> &nbsp; Bắt đầu tải</vs-button>
                    <vs-button square danger @click="uploadDone"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
                </div>
            </template>
        </vs-dialog>
	</div>
</template>
<style lang="scss">
    #briefings-report-create {
        .form-control-file {
            margin-top: 5px;
        }
    }
</style>

